const Zi_3=[
    {
        "Name": "LG01",
        "Length": 207033452
    },
    {
        "Name": "LG02",
        "Length": 108890327
    },
    {
        "Name": "LG03",
        "Length": 108283300
    },
    {
        "Name": "LG04",
        "Length": 87797278
    },
    {
        "Name": "LG05",
        "Length": 81838312
    },
    {
        "Name": "LG06",
        "Length": 67615458
    },
    {
        "Name": "LG07",
        "Length": 59450702
    },
    {
        "Name": "LG08",
        "Length": 57318725
    },
    {
        "Name": "Contig1",
        "Length": 274032
    },
    {
        "Name": "Contig2",
        "Length": 250499
    },
    {
        "Name": "Contig3",
        "Length": 235529
    },
    {
        "Name": "Contig4",
        "Length": 190642
    },
    {
        "Name": "Contig5",
        "Length": 189799
    },
    {
        "Name": "Contig6",
        "Length": 160223
    },
    {
        "Name": "Contig7",
        "Length": 143407
    },
    {
        "Name": "Contig8",
        "Length": 143172
    },
    {
        "Name": "Contig9",
        "Length": 142698
    },
    {
        "Name": "Contig10",
        "Length": 131313
    },
    {
        "Name": "Contig11",
        "Length": 125422
    },
    {
        "Name": "Contig12",
        "Length": 124821
    },
    {
        "Name": "Contig13",
        "Length": 123655
    },
    {
        "Name": "Contig14",
        "Length": 120884
    },
    {
        "Name": "Contig15",
        "Length": 120318
    },
    {
        "Name": "Contig16",
        "Length": 113497
    },
    {
        "Name": "Contig17",
        "Length": 108478
    },
    {
        "Name": "Contig18",
        "Length": 106606
    },
    {
        "Name": "Contig19",
        "Length": 104632
    },
    {
        "Name": "Contig20",
        "Length": 104377
    },
    {
        "Name": "Contig21",
        "Length": 98050
    },
    {
        "Name": "Contig22",
        "Length": 93988
    },
    {
        "Name": "Contig23",
        "Length": 91831
    },
    {
        "Name": "Contig24",
        "Length": 90262
    },
    {
        "Name": "Contig25",
        "Length": 88400
    },
    {
        "Name": "Contig26",
        "Length": 87908
    },
    {
        "Name": "Contig27",
        "Length": 83838
    },
    {
        "Name": "Contig28",
        "Length": 81784
    },
    {
        "Name": "Contig29",
        "Length": 81478
    },
    {
        "Name": "Contig30",
        "Length": 74479
    },
    {
        "Name": "Contig31",
        "Length": 74419
    },
    {
        "Name": "Contig32",
        "Length": 74111
    },
    {
        "Name": "Contig33",
        "Length": 74049
    },
    {
        "Name": "Contig34",
        "Length": 73835
    },
    {
        "Name": "Contig35",
        "Length": 72761
    },
    {
        "Name": "Contig36",
        "Length": 72456
    },
    {
        "Name": "Contig37",
        "Length": 71415
    },
    {
        "Name": "Contig38",
        "Length": 71292
    },
    {
        "Name": "Contig39",
        "Length": 69665
    },
    {
        "Name": "Contig40",
        "Length": 68218
    },
    {
        "Name": "Contig41",
        "Length": 67325
    },
    {
        "Name": "Contig42",
        "Length": 64101
    },
    {
        "Name": "Contig43",
        "Length": 62213
    },
    {
        "Name": "Contig44",
        "Length": 61192
    },
    {
        "Name": "Contig45",
        "Length": 60522
    },
    {
        "Name": "Contig46",
        "Length": 60363
    },
    {
        "Name": "Contig47",
        "Length": 60231
    },
    {
        "Name": "Contig48",
        "Length": 60105
    },
    {
        "Name": "Contig49",
        "Length": 60066
    },
    {
        "Name": "Contig50",
        "Length": 60006
    },
    {
        "Name": "Contig51",
        "Length": 59265
    },
    {
        "Name": "Contig52",
        "Length": 59064
    },
    {
        "Name": "Contig53",
        "Length": 57610
    },
    {
        "Name": "Contig54",
        "Length": 57594
    },
    {
        "Name": "Contig55",
        "Length": 57102
    },
    {
        "Name": "Contig56",
        "Length": 56980
    },
    {
        "Name": "Contig57",
        "Length": 56243
    },
    {
        "Name": "Contig58",
        "Length": 56240
    },
    {
        "Name": "Contig59",
        "Length": 55427
    },
    {
        "Name": "Contig60",
        "Length": 54724
    },
    {
        "Name": "Contig61",
        "Length": 54496
    },
    {
        "Name": "Contig62",
        "Length": 54425
    },
    {
        "Name": "Contig63",
        "Length": 53981
    },
    {
        "Name": "Contig64",
        "Length": 53617
    },
    {
        "Name": "Contig65",
        "Length": 53160
    },
    {
        "Name": "Contig66",
        "Length": 53155
    },
    {
        "Name": "Contig67",
        "Length": 52637
    },
    {
        "Name": "Contig68",
        "Length": 52501
    },
    {
        "Name": "Contig69",
        "Length": 52065
    },
    {
        "Name": "Contig70",
        "Length": 52029
    },
    {
        "Name": "Contig71",
        "Length": 52016
    },
    {
        "Name": "Contig72",
        "Length": 51520
    },
    {
        "Name": "Contig73",
        "Length": 49191
    },
    {
        "Name": "Contig74",
        "Length": 49060
    },
    {
        "Name": "Contig75",
        "Length": 49010
    },
    {
        "Name": "Contig76",
        "Length": 48995
    },
    {
        "Name": "Contig77",
        "Length": 48808
    },
    {
        "Name": "Contig78",
        "Length": 48617
    },
    {
        "Name": "Contig79",
        "Length": 48590
    },
    {
        "Name": "Contig80",
        "Length": 48438
    },
    {
        "Name": "Contig81",
        "Length": 48432
    },
    {
        "Name": "Contig82",
        "Length": 48104
    },
    {
        "Name": "Contig83",
        "Length": 48065
    },
    {
        "Name": "Contig84",
        "Length": 46535
    },
    {
        "Name": "Contig85",
        "Length": 46268
    },
    {
        "Name": "Contig86",
        "Length": 46201
    },
    {
        "Name": "Contig87",
        "Length": 45105
    },
    {
        "Name": "Contig88",
        "Length": 45016
    },
    {
        "Name": "Contig89",
        "Length": 45015
    },
    {
        "Name": "Contig90",
        "Length": 44643
    },
    {
        "Name": "Contig91",
        "Length": 44205
    },
    {
        "Name": "Contig92",
        "Length": 44194
    },
    {
        "Name": "Contig93",
        "Length": 44099
    },
    {
        "Name": "Contig94",
        "Length": 44044
    },
    {
        "Name": "Contig95",
        "Length": 43945
    },
    {
        "Name": "Contig96",
        "Length": 43468
    },
    {
        "Name": "Contig97",
        "Length": 43302
    },
    {
        "Name": "Contig98",
        "Length": 43243
    },
    {
        "Name": "Contig99",
        "Length": 43140
    },
    {
        "Name": "Contig100",
        "Length": 43054
    },
    {
        "Name": "Contig101",
        "Length": 43007
    },
    {
        "Name": "Contig102",
        "Length": 43004
    },
    {
        "Name": "Contig103",
        "Length": 43001
    },
    {
        "Name": "Contig104",
        "Length": 42476
    },
    {
        "Name": "Contig105",
        "Length": 42462
    },
    {
        "Name": "Contig106",
        "Length": 42193
    },
    {
        "Name": "Contig107",
        "Length": 41669
    },
    {
        "Name": "Contig108",
        "Length": 41359
    },
    {
        "Name": "Contig109",
        "Length": 41336
    },
    {
        "Name": "Contig110",
        "Length": 41193
    },
    {
        "Name": "Contig111",
        "Length": 41123
    },
    {
        "Name": "Contig112",
        "Length": 41062
    },
    {
        "Name": "Contig113",
        "Length": 41044
    },
    {
        "Name": "Contig114",
        "Length": 41001
    },
    {
        "Name": "Contig115",
        "Length": 40941
    },
    {
        "Name": "Contig116",
        "Length": 40741
    },
    {
        "Name": "Contig117",
        "Length": 40555
    },
    {
        "Name": "Contig118",
        "Length": 40065
    },
    {
        "Name": "Contig119",
        "Length": 40032
    },
    {
        "Name": "Contig120",
        "Length": 40031
    },
    {
        "Name": "Contig121",
        "Length": 39395
    },
    {
        "Name": "Contig122",
        "Length": 39227
    },
    {
        "Name": "Contig123",
        "Length": 39097
    },
    {
        "Name": "Contig124",
        "Length": 39082
    },
    {
        "Name": "Contig125",
        "Length": 39020
    },
    {
        "Name": "Contig126",
        "Length": 39017
    },
    {
        "Name": "Contig127",
        "Length": 39013
    },
    {
        "Name": "Contig128",
        "Length": 38996
    },
    {
        "Name": "Contig129",
        "Length": 38734
    },
    {
        "Name": "Contig130",
        "Length": 38506
    },
    {
        "Name": "Contig131",
        "Length": 38258
    },
    {
        "Name": "Contig132",
        "Length": 38021
    },
    {
        "Name": "Contig133",
        "Length": 38014
    },
    {
        "Name": "Contig134",
        "Length": 37609
    },
    {
        "Name": "Contig135",
        "Length": 37346
    },
    {
        "Name": "Contig136",
        "Length": 37270
    },
    {
        "Name": "Contig137",
        "Length": 37229
    },
    {
        "Name": "Contig138",
        "Length": 37227
    },
    {
        "Name": "Contig139",
        "Length": 37062
    },
    {
        "Name": "Contig140",
        "Length": 37043
    },
    {
        "Name": "Contig141",
        "Length": 37022
    },
    {
        "Name": "Contig142",
        "Length": 37004
    },
    {
        "Name": "Contig143",
        "Length": 36990
    },
    {
        "Name": "Contig144",
        "Length": 36524
    },
    {
        "Name": "Contig145",
        "Length": 36221
    },
    {
        "Name": "Contig146",
        "Length": 36163
    },
    {
        "Name": "Contig147",
        "Length": 36141
    },
    {
        "Name": "Contig148",
        "Length": 36118
    },
    {
        "Name": "Contig149",
        "Length": 36113
    },
    {
        "Name": "Contig150",
        "Length": 36058
    },
    {
        "Name": "Contig151",
        "Length": 36055
    },
    {
        "Name": "Contig152",
        "Length": 36028
    },
    {
        "Name": "Contig153",
        "Length": 36022
    },
    {
        "Name": "Contig154",
        "Length": 36017
    },
    {
        "Name": "Contig155",
        "Length": 35722
    },
    {
        "Name": "Contig156",
        "Length": 35169
    },
    {
        "Name": "Contig157",
        "Length": 35133
    },
    {
        "Name": "Contig158",
        "Length": 35061
    },
    {
        "Name": "Contig159",
        "Length": 35016
    },
    {
        "Name": "Contig160",
        "Length": 35011
    },
    {
        "Name": "Contig161",
        "Length": 35004
    },
    {
        "Name": "Contig162",
        "Length": 34732
    },
    {
        "Name": "Contig163",
        "Length": 34246
    },
    {
        "Name": "Contig164",
        "Length": 34170
    },
    {
        "Name": "Contig165",
        "Length": 34108
    },
    {
        "Name": "Contig166",
        "Length": 34070
    },
    {
        "Name": "Contig167",
        "Length": 34068
    },
    {
        "Name": "Contig168",
        "Length": 34058
    },
    {
        "Name": "Contig169",
        "Length": 33994
    },
    {
        "Name": "Contig170",
        "Length": 33470
    },
    {
        "Name": "Contig171",
        "Length": 33412
    },
    {
        "Name": "Contig172",
        "Length": 33251
    },
    {
        "Name": "Contig173",
        "Length": 33147
    },
    {
        "Name": "Contig174",
        "Length": 33042
    },
    {
        "Name": "Contig175",
        "Length": 32999
    },
    {
        "Name": "Contig176",
        "Length": 32995
    },
    {
        "Name": "Contig177",
        "Length": 32341
    },
    {
        "Name": "Contig178",
        "Length": 32294
    },
    {
        "Name": "Contig179",
        "Length": 32164
    },
    {
        "Name": "Contig180",
        "Length": 32159
    },
    {
        "Name": "Contig181",
        "Length": 32151
    },
    {
        "Name": "Contig182",
        "Length": 32081
    },
    {
        "Name": "Contig183",
        "Length": 32063
    },
    {
        "Name": "Contig184",
        "Length": 32047
    },
    {
        "Name": "Contig185",
        "Length": 32047
    },
    {
        "Name": "Contig186",
        "Length": 32040
    },
    {
        "Name": "Contig187",
        "Length": 32026
    },
    {
        "Name": "Contig188",
        "Length": 31715
    },
    {
        "Name": "Contig189",
        "Length": 31581
    },
    {
        "Name": "Contig190",
        "Length": 31459
    },
    {
        "Name": "Contig191",
        "Length": 31322
    },
    {
        "Name": "Contig192",
        "Length": 31302
    },
    {
        "Name": "Contig193",
        "Length": 31190
    },
    {
        "Name": "Contig194",
        "Length": 31144
    },
    {
        "Name": "Contig195",
        "Length": 31101
    },
    {
        "Name": "Contig196",
        "Length": 31069
    },
    {
        "Name": "Contig197",
        "Length": 31068
    },
    {
        "Name": "Contig198",
        "Length": 31056
    },
    {
        "Name": "Contig199",
        "Length": 31032
    },
    {
        "Name": "Contig200",
        "Length": 30830
    },
    {
        "Name": "Contig201",
        "Length": 30688
    },
    {
        "Name": "Contig202",
        "Length": 30522
    },
    {
        "Name": "Contig203",
        "Length": 30435
    },
    {
        "Name": "Contig204",
        "Length": 30367
    },
    {
        "Name": "Contig205",
        "Length": 30362
    },
    {
        "Name": "Contig206",
        "Length": 30164
    },
    {
        "Name": "Contig207",
        "Length": 30121
    },
    {
        "Name": "Contig208",
        "Length": 30078
    },
    {
        "Name": "Contig209",
        "Length": 30048
    },
    {
        "Name": "Contig210",
        "Length": 30040
    },
    {
        "Name": "Contig211",
        "Length": 30030
    },
    {
        "Name": "Contig212",
        "Length": 30011
    },
    {
        "Name": "Contig213",
        "Length": 30008
    },
    {
        "Name": "Contig214",
        "Length": 29448
    },
    {
        "Name": "Contig215",
        "Length": 29347
    },
    {
        "Name": "Contig216",
        "Length": 29313
    },
    {
        "Name": "Contig217",
        "Length": 29203
    },
    {
        "Name": "Contig218",
        "Length": 29143
    },
    {
        "Name": "Contig219",
        "Length": 29140
    },
    {
        "Name": "Contig220",
        "Length": 29128
    },
    {
        "Name": "Contig221",
        "Length": 29071
    },
    {
        "Name": "Contig222",
        "Length": 29056
    },
    {
        "Name": "Contig223",
        "Length": 29047
    },
    {
        "Name": "Contig224",
        "Length": 29031
    },
    {
        "Name": "Contig225",
        "Length": 29028
    },
    {
        "Name": "Contig226",
        "Length": 29026
    },
    {
        "Name": "Contig227",
        "Length": 29023
    },
    {
        "Name": "Contig228",
        "Length": 29007
    },
    {
        "Name": "Contig229",
        "Length": 29004
    },
    {
        "Name": "Contig230",
        "Length": 29002
    },
    {
        "Name": "Contig231",
        "Length": 29000
    },
    {
        "Name": "Contig232",
        "Length": 28989
    },
    {
        "Name": "Contig233",
        "Length": 28392
    },
    {
        "Name": "Contig234",
        "Length": 28380
    },
    {
        "Name": "Contig235",
        "Length": 28172
    },
    {
        "Name": "Contig236",
        "Length": 28163
    },
    {
        "Name": "Contig237",
        "Length": 28137
    },
    {
        "Name": "Contig238",
        "Length": 28126
    },
    {
        "Name": "Contig239",
        "Length": 28085
    },
    {
        "Name": "Contig240",
        "Length": 28067
    },
    {
        "Name": "Contig241",
        "Length": 28052
    },
    {
        "Name": "Contig242",
        "Length": 28049
    },
    {
        "Name": "Contig243",
        "Length": 28032
    },
    {
        "Name": "Contig244",
        "Length": 28007
    },
    {
        "Name": "Contig245",
        "Length": 28004
    },
    {
        "Name": "Contig246",
        "Length": 28002
    },
    {
        "Name": "Contig247",
        "Length": 27998
    },
    {
        "Name": "Contig248",
        "Length": 27995
    },
    {
        "Name": "Contig249",
        "Length": 27995
    },
    {
        "Name": "Contig250",
        "Length": 27994
    },
    {
        "Name": "Contig251",
        "Length": 27991
    },
    {
        "Name": "Contig252",
        "Length": 27706
    },
    {
        "Name": "Contig253",
        "Length": 27202
    },
    {
        "Name": "Contig254",
        "Length": 27187
    },
    {
        "Name": "Contig255",
        "Length": 27175
    },
    {
        "Name": "Contig256",
        "Length": 27170
    },
    {
        "Name": "Contig257",
        "Length": 27148
    },
    {
        "Name": "Contig258",
        "Length": 27144
    },
    {
        "Name": "Contig259",
        "Length": 27122
    },
    {
        "Name": "Contig260",
        "Length": 27118
    },
    {
        "Name": "Contig261",
        "Length": 27116
    },
    {
        "Name": "Contig262",
        "Length": 27095
    },
    {
        "Name": "Contig263",
        "Length": 27079
    },
    {
        "Name": "Contig264",
        "Length": 27046
    },
    {
        "Name": "Contig265",
        "Length": 27044
    },
    {
        "Name": "Contig266",
        "Length": 27040
    },
    {
        "Name": "Contig267",
        "Length": 27038
    },
    {
        "Name": "Contig268",
        "Length": 27028
    },
    {
        "Name": "Contig269",
        "Length": 27028
    },
    {
        "Name": "Contig270",
        "Length": 27021
    },
    {
        "Name": "Contig271",
        "Length": 27005
    },
    {
        "Name": "Contig272",
        "Length": 27004
    },
    {
        "Name": "Contig273",
        "Length": 27000
    },
    {
        "Name": "Contig274",
        "Length": 26996
    },
    {
        "Name": "Contig275",
        "Length": 26991
    },
    {
        "Name": "Contig276",
        "Length": 26988
    },
    {
        "Name": "Contig277",
        "Length": 26796
    },
    {
        "Name": "Contig278",
        "Length": 26275
    },
    {
        "Name": "Contig279",
        "Length": 26123
    },
    {
        "Name": "Contig280",
        "Length": 26111
    },
    {
        "Name": "Contig281",
        "Length": 26085
    },
    {
        "Name": "Contig282",
        "Length": 26044
    },
    {
        "Name": "Contig283",
        "Length": 26042
    },
    {
        "Name": "Contig284",
        "Length": 26018
    },
    {
        "Name": "Contig285",
        "Length": 26016
    },
    {
        "Name": "Contig286",
        "Length": 26014
    },
    {
        "Name": "Contig287",
        "Length": 25997
    },
    {
        "Name": "Contig288",
        "Length": 25995
    },
    {
        "Name": "Contig289",
        "Length": 25992
    },
    {
        "Name": "Contig290",
        "Length": 25988
    },
    {
        "Name": "Contig291",
        "Length": 25608
    },
    {
        "Name": "Contig292",
        "Length": 25447
    },
    {
        "Name": "Contig293",
        "Length": 25395
    },
    {
        "Name": "Contig294",
        "Length": 25324
    },
    {
        "Name": "Contig295",
        "Length": 25293
    },
    {
        "Name": "Contig296",
        "Length": 25277
    },
    {
        "Name": "Contig297",
        "Length": 25235
    },
    {
        "Name": "Contig298",
        "Length": 25162
    },
    {
        "Name": "Contig299",
        "Length": 25123
    },
    {
        "Name": "Contig300",
        "Length": 25121
    },
    {
        "Name": "Contig301",
        "Length": 25101
    },
    {
        "Name": "Contig302",
        "Length": 25087
    },
    {
        "Name": "Contig303",
        "Length": 25068
    },
    {
        "Name": "Contig304",
        "Length": 25038
    },
    {
        "Name": "Contig305",
        "Length": 25033
    },
    {
        "Name": "Contig306",
        "Length": 25032
    },
    {
        "Name": "Contig307",
        "Length": 25030
    },
    {
        "Name": "Contig308",
        "Length": 25015
    },
    {
        "Name": "Contig309",
        "Length": 25009
    },
    {
        "Name": "Contig310",
        "Length": 25006
    },
    {
        "Name": "Contig311",
        "Length": 25004
    },
    {
        "Name": "Contig312",
        "Length": 25004
    },
    {
        "Name": "Contig313",
        "Length": 25002
    },
    {
        "Name": "Contig314",
        "Length": 24999
    },
    {
        "Name": "Contig315",
        "Length": 24992
    },
    {
        "Name": "Contig316",
        "Length": 24989
    },
    {
        "Name": "Contig317",
        "Length": 24988
    },
    {
        "Name": "Contig318",
        "Length": 24972
    },
    {
        "Name": "Contig319",
        "Length": 24570
    },
    {
        "Name": "Contig320",
        "Length": 24397
    },
    {
        "Name": "Contig321",
        "Length": 24269
    },
    {
        "Name": "Contig322",
        "Length": 24226
    },
    {
        "Name": "Contig323",
        "Length": 24223
    },
    {
        "Name": "Contig324",
        "Length": 24200
    },
    {
        "Name": "Contig325",
        "Length": 24143
    },
    {
        "Name": "Contig326",
        "Length": 24110
    },
    {
        "Name": "Contig327",
        "Length": 24081
    },
    {
        "Name": "Contig328",
        "Length": 24075
    },
    {
        "Name": "Contig329",
        "Length": 24055
    },
    {
        "Name": "Contig330",
        "Length": 24045
    },
    {
        "Name": "Contig331",
        "Length": 24034
    },
    {
        "Name": "Contig332",
        "Length": 24031
    },
    {
        "Name": "Contig333",
        "Length": 24027
    },
    {
        "Name": "Contig334",
        "Length": 24017
    },
    {
        "Name": "Contig335",
        "Length": 24013
    },
    {
        "Name": "Contig336",
        "Length": 24005
    },
    {
        "Name": "Contig337",
        "Length": 24004
    },
    {
        "Name": "Contig338",
        "Length": 24003
    },
    {
        "Name": "Contig339",
        "Length": 24002
    },
    {
        "Name": "Contig340",
        "Length": 24001
    },
    {
        "Name": "Contig341",
        "Length": 23997
    },
    {
        "Name": "Contig342",
        "Length": 23996
    },
    {
        "Name": "Contig343",
        "Length": 23994
    },
    {
        "Name": "Contig344",
        "Length": 23992
    },
    {
        "Name": "Contig345",
        "Length": 23989
    },
    {
        "Name": "Contig346",
        "Length": 23988
    },
    {
        "Name": "Contig347",
        "Length": 23586
    },
    {
        "Name": "Contig348",
        "Length": 23364
    },
    {
        "Name": "Contig349",
        "Length": 23300
    },
    {
        "Name": "Contig350",
        "Length": 23233
    },
    {
        "Name": "Contig351",
        "Length": 23201
    },
    {
        "Name": "Contig352",
        "Length": 23136
    },
    {
        "Name": "Contig353",
        "Length": 23108
    },
    {
        "Name": "Contig354",
        "Length": 23088
    },
    {
        "Name": "Contig355",
        "Length": 23076
    },
    {
        "Name": "Contig356",
        "Length": 23063
    },
    {
        "Name": "Contig357",
        "Length": 23063
    },
    {
        "Name": "Contig358",
        "Length": 23051
    },
    {
        "Name": "Contig359",
        "Length": 23035
    },
    {
        "Name": "Contig360",
        "Length": 23034
    },
    {
        "Name": "Contig361",
        "Length": 23023
    },
    {
        "Name": "Contig362",
        "Length": 23020
    },
    {
        "Name": "Contig363",
        "Length": 23014
    },
    {
        "Name": "Contig364",
        "Length": 23007
    },
    {
        "Name": "Contig365",
        "Length": 23003
    },
    {
        "Name": "Contig366",
        "Length": 23000
    },
    {
        "Name": "Contig367",
        "Length": 23000
    },
    {
        "Name": "Contig368",
        "Length": 22994
    },
    {
        "Name": "Contig369",
        "Length": 22991
    },
    {
        "Name": "Contig370",
        "Length": 22991
    },
    {
        "Name": "Contig371",
        "Length": 22682
    },
    {
        "Name": "Contig372",
        "Length": 22435
    },
    {
        "Name": "Contig373",
        "Length": 22315
    },
    {
        "Name": "Contig374",
        "Length": 22225
    },
    {
        "Name": "Contig375",
        "Length": 22198
    },
    {
        "Name": "Contig376",
        "Length": 22194
    },
    {
        "Name": "Contig377",
        "Length": 22110
    },
    {
        "Name": "Contig378",
        "Length": 22103
    },
    {
        "Name": "Contig379",
        "Length": 22086
    },
    {
        "Name": "Contig380",
        "Length": 22057
    },
    {
        "Name": "Contig381",
        "Length": 22055
    },
    {
        "Name": "Contig382",
        "Length": 22052
    },
    {
        "Name": "Contig383",
        "Length": 22049
    },
    {
        "Name": "Contig384",
        "Length": 22046
    },
    {
        "Name": "Contig385",
        "Length": 22043
    },
    {
        "Name": "Contig386",
        "Length": 22035
    },
    {
        "Name": "Contig387",
        "Length": 22031
    },
    {
        "Name": "Contig388",
        "Length": 22031
    },
    {
        "Name": "Contig389",
        "Length": 22022
    },
    {
        "Name": "Contig390",
        "Length": 22021
    },
    {
        "Name": "Contig391",
        "Length": 22019
    },
    {
        "Name": "Contig392",
        "Length": 22014
    },
    {
        "Name": "Contig393",
        "Length": 22013
    },
    {
        "Name": "Contig394",
        "Length": 22009
    },
    {
        "Name": "Contig395",
        "Length": 22007
    },
    {
        "Name": "Contig396",
        "Length": 22006
    },
    {
        "Name": "Contig397",
        "Length": 21999
    },
    {
        "Name": "Contig398",
        "Length": 21998
    },
    {
        "Name": "Contig399",
        "Length": 21997
    },
    {
        "Name": "Contig400",
        "Length": 21995
    },
    {
        "Name": "Contig401",
        "Length": 21994
    },
    {
        "Name": "Contig402",
        "Length": 21994
    },
    {
        "Name": "Contig403",
        "Length": 21992
    },
    {
        "Name": "Contig404",
        "Length": 21992
    },
    {
        "Name": "Contig405",
        "Length": 21991
    },
    {
        "Name": "Contig406",
        "Length": 21989
    },
    {
        "Name": "Contig407",
        "Length": 21988
    },
    {
        "Name": "Contig408",
        "Length": 21988
    },
    {
        "Name": "Contig409",
        "Length": 21854
    },
    {
        "Name": "Contig410",
        "Length": 21310
    },
    {
        "Name": "Contig411",
        "Length": 21246
    },
    {
        "Name": "Contig412",
        "Length": 21245
    },
    {
        "Name": "Contig413",
        "Length": 21225
    },
    {
        "Name": "Contig414",
        "Length": 21174
    },
    {
        "Name": "Contig415",
        "Length": 21147
    },
    {
        "Name": "Contig416",
        "Length": 21099
    },
    {
        "Name": "Contig417",
        "Length": 21094
    },
    {
        "Name": "Contig418",
        "Length": 21081
    },
    {
        "Name": "Contig419",
        "Length": 21047
    },
    {
        "Name": "Contig420",
        "Length": 21045
    },
    {
        "Name": "Contig421",
        "Length": 21040
    },
    {
        "Name": "Contig422",
        "Length": 21030
    },
    {
        "Name": "Contig423",
        "Length": 21028
    },
    {
        "Name": "Contig424",
        "Length": 21017
    },
    {
        "Name": "Contig425",
        "Length": 21016
    },
    {
        "Name": "Contig426",
        "Length": 21016
    },
    {
        "Name": "Contig427",
        "Length": 21016
    },
    {
        "Name": "Contig428",
        "Length": 21012
    },
    {
        "Name": "Contig429",
        "Length": 21010
    },
    {
        "Name": "Contig430",
        "Length": 21008
    },
    {
        "Name": "Contig431",
        "Length": 21007
    },
    {
        "Name": "Contig432",
        "Length": 21007
    },
    {
        "Name": "Contig433",
        "Length": 20999
    },
    {
        "Name": "Contig434",
        "Length": 20999
    },
    {
        "Name": "Contig435",
        "Length": 20994
    },
    {
        "Name": "Contig436",
        "Length": 20992
    },
    {
        "Name": "Contig437",
        "Length": 20992
    },
    {
        "Name": "Contig438",
        "Length": 20992
    },
    {
        "Name": "Contig439",
        "Length": 20991
    },
    {
        "Name": "Contig440",
        "Length": 20990
    },
    {
        "Name": "Contig441",
        "Length": 20989
    },
    {
        "Name": "Contig442",
        "Length": 20988
    },
    {
        "Name": "Contig443",
        "Length": 20988
    },
    {
        "Name": "Contig444",
        "Length": 20979
    },
    {
        "Name": "Contig445",
        "Length": 20558
    },
    {
        "Name": "Contig446",
        "Length": 20325
    },
    {
        "Name": "Contig447",
        "Length": 20192
    },
    {
        "Name": "Contig448",
        "Length": 20190
    },
    {
        "Name": "Contig449",
        "Length": 20172
    },
    {
        "Name": "Contig450",
        "Length": 20142
    },
    {
        "Name": "Contig451",
        "Length": 20129
    },
    {
        "Name": "Contig452",
        "Length": 20103
    },
    {
        "Name": "Contig453",
        "Length": 20092
    },
    {
        "Name": "Contig454",
        "Length": 20068
    },
    {
        "Name": "Contig455",
        "Length": 20049
    },
    {
        "Name": "Contig456",
        "Length": 20042
    },
    {
        "Name": "Contig457",
        "Length": 20041
    },
    {
        "Name": "Contig458",
        "Length": 20034
    },
    {
        "Name": "Contig459",
        "Length": 20031
    },
    {
        "Name": "Contig460",
        "Length": 20017
    },
    {
        "Name": "Contig461",
        "Length": 20014
    },
    {
        "Name": "Contig462",
        "Length": 20009
    },
    {
        "Name": "Contig463",
        "Length": 20007
    },
    {
        "Name": "Contig464",
        "Length": 20004
    },
    {
        "Name": "Contig465",
        "Length": 20002
    },
    {
        "Name": "Contig466",
        "Length": 19999
    },
    {
        "Name": "Contig467",
        "Length": 19994
    },
    {
        "Name": "Contig468",
        "Length": 19994
    },
    {
        "Name": "Contig469",
        "Length": 19988
    },
    {
        "Name": "Contig470",
        "Length": 19831
    },
    {
        "Name": "Contig471",
        "Length": 19309
    },
    {
        "Name": "Contig472",
        "Length": 19283
    },
    {
        "Name": "Contig473",
        "Length": 19134
    },
    {
        "Name": "Contig474",
        "Length": 19121
    },
    {
        "Name": "Contig475",
        "Length": 19089
    },
    {
        "Name": "Contig476",
        "Length": 19087
    },
    {
        "Name": "Contig477",
        "Length": 19067
    },
    {
        "Name": "Contig478",
        "Length": 19061
    },
    {
        "Name": "Contig479",
        "Length": 19058
    },
    {
        "Name": "Contig480",
        "Length": 19057
    },
    {
        "Name": "Contig481",
        "Length": 19054
    },
    {
        "Name": "Contig482",
        "Length": 19041
    },
    {
        "Name": "Contig483",
        "Length": 19037
    },
    {
        "Name": "Contig484",
        "Length": 19027
    },
    {
        "Name": "Contig485",
        "Length": 19019
    },
    {
        "Name": "Contig486",
        "Length": 19011
    },
    {
        "Name": "Contig487",
        "Length": 19005
    },
    {
        "Name": "Contig488",
        "Length": 19002
    },
    {
        "Name": "Contig489",
        "Length": 19000
    },
    {
        "Name": "Contig490",
        "Length": 18997
    },
    {
        "Name": "Contig491",
        "Length": 18996
    },
    {
        "Name": "Contig492",
        "Length": 18995
    },
    {
        "Name": "Contig493",
        "Length": 18992
    },
    {
        "Name": "Contig494",
        "Length": 18992
    },
    {
        "Name": "Contig495",
        "Length": 18989
    },
    {
        "Name": "Contig496",
        "Length": 18988
    },
    {
        "Name": "Contig497",
        "Length": 18988
    },
    {
        "Name": "Contig498",
        "Length": 18988
    },
    {
        "Name": "Contig499",
        "Length": 18988
    },
    {
        "Name": "Contig500",
        "Length": 18754
    },
    {
        "Name": "Contig501",
        "Length": 18514
    },
    {
        "Name": "Contig502",
        "Length": 18261
    },
    {
        "Name": "Contig503",
        "Length": 18229
    },
    {
        "Name": "Contig504",
        "Length": 18222
    },
    {
        "Name": "Contig505",
        "Length": 18187
    },
    {
        "Name": "Contig506",
        "Length": 18060
    },
    {
        "Name": "Contig507",
        "Length": 18041
    },
    {
        "Name": "Contig508",
        "Length": 18040
    },
    {
        "Name": "Contig509",
        "Length": 18031
    },
    {
        "Name": "Contig510",
        "Length": 18027
    },
    {
        "Name": "Contig511",
        "Length": 18026
    },
    {
        "Name": "Contig512",
        "Length": 18025
    },
    {
        "Name": "Contig513",
        "Length": 18024
    },
    {
        "Name": "Contig514",
        "Length": 18022
    },
    {
        "Name": "Contig515",
        "Length": 18014
    },
    {
        "Name": "Contig516",
        "Length": 18013
    },
    {
        "Name": "Contig517",
        "Length": 18013
    },
    {
        "Name": "Contig518",
        "Length": 18013
    },
    {
        "Name": "Contig519",
        "Length": 18011
    },
    {
        "Name": "Contig520",
        "Length": 18008
    },
    {
        "Name": "Contig521",
        "Length": 18000
    },
    {
        "Name": "Contig522",
        "Length": 17995
    },
    {
        "Name": "Contig523",
        "Length": 17992
    },
    {
        "Name": "Contig524",
        "Length": 17991
    },
    {
        "Name": "Contig525",
        "Length": 17991
    },
    {
        "Name": "Contig526",
        "Length": 17991
    },
    {
        "Name": "Contig527",
        "Length": 17989
    },
    {
        "Name": "Contig528",
        "Length": 17989
    },
    {
        "Name": "Contig529",
        "Length": 17989
    },
    {
        "Name": "Contig530",
        "Length": 17989
    },
    {
        "Name": "Contig531",
        "Length": 17988
    },
    {
        "Name": "Contig532",
        "Length": 17988
    },
    {
        "Name": "Contig533",
        "Length": 17988
    },
    {
        "Name": "Contig534",
        "Length": 17352
    },
    {
        "Name": "Contig535",
        "Length": 17305
    },
    {
        "Name": "Contig536",
        "Length": 17191
    },
    {
        "Name": "Contig537",
        "Length": 17152
    },
    {
        "Name": "Contig538",
        "Length": 17136
    },
    {
        "Name": "Contig539",
        "Length": 17107
    },
    {
        "Name": "Contig540",
        "Length": 17093
    },
    {
        "Name": "Contig541",
        "Length": 17092
    },
    {
        "Name": "Contig542",
        "Length": 17064
    },
    {
        "Name": "Contig543",
        "Length": 17061
    },
    {
        "Name": "Contig544",
        "Length": 17060
    },
    {
        "Name": "Contig545",
        "Length": 17051
    },
    {
        "Name": "Contig546",
        "Length": 17046
    },
    {
        "Name": "Contig547",
        "Length": 17046
    },
    {
        "Name": "Contig548",
        "Length": 17044
    },
    {
        "Name": "Contig549",
        "Length": 17035
    },
    {
        "Name": "Contig550",
        "Length": 17031
    },
    {
        "Name": "Contig551",
        "Length": 17027
    },
    {
        "Name": "Contig552",
        "Length": 17022
    },
    {
        "Name": "Contig553",
        "Length": 17017
    },
    {
        "Name": "Contig554",
        "Length": 17012
    },
    {
        "Name": "Contig555",
        "Length": 17010
    },
    {
        "Name": "Contig556",
        "Length": 17007
    },
    {
        "Name": "Contig557",
        "Length": 17007
    },
    {
        "Name": "Contig558",
        "Length": 17004
    },
    {
        "Name": "Contig559",
        "Length": 17004
    },
    {
        "Name": "Contig560",
        "Length": 17002
    },
    {
        "Name": "Contig561",
        "Length": 17002
    },
    {
        "Name": "Contig562",
        "Length": 17000
    },
    {
        "Name": "Contig563",
        "Length": 16998
    },
    {
        "Name": "Contig564",
        "Length": 16998
    },
    {
        "Name": "Contig565",
        "Length": 16998
    },
    {
        "Name": "Contig566",
        "Length": 16995
    },
    {
        "Name": "Contig567",
        "Length": 16995
    },
    {
        "Name": "Contig568",
        "Length": 16994
    },
    {
        "Name": "Contig569",
        "Length": 16990
    },
    {
        "Name": "Contig570",
        "Length": 16988
    },
    {
        "Name": "Contig571",
        "Length": 16988
    },
    {
        "Name": "Contig572",
        "Length": 16988
    },
    {
        "Name": "Contig573",
        "Length": 16672
    },
    {
        "Name": "Contig574",
        "Length": 16373
    },
    {
        "Name": "Contig575",
        "Length": 16292
    },
    {
        "Name": "Contig576",
        "Length": 16270
    },
    {
        "Name": "Contig577",
        "Length": 16260
    },
    {
        "Name": "Contig578",
        "Length": 16233
    },
    {
        "Name": "Contig579",
        "Length": 16182
    },
    {
        "Name": "Contig580",
        "Length": 16162
    },
    {
        "Name": "Contig581",
        "Length": 16140
    },
    {
        "Name": "Contig582",
        "Length": 16116
    },
    {
        "Name": "Contig583",
        "Length": 16104
    },
    {
        "Name": "Contig584",
        "Length": 16090
    },
    {
        "Name": "Contig585",
        "Length": 16050
    },
    {
        "Name": "Contig586",
        "Length": 16041
    },
    {
        "Name": "Contig587",
        "Length": 16038
    },
    {
        "Name": "Contig588",
        "Length": 16038
    },
    {
        "Name": "Contig589",
        "Length": 16037
    },
    {
        "Name": "Contig590",
        "Length": 16031
    },
    {
        "Name": "Contig591",
        "Length": 16024
    },
    {
        "Name": "Contig592",
        "Length": 16020
    },
    {
        "Name": "Contig593",
        "Length": 16020
    },
    {
        "Name": "Contig594",
        "Length": 16012
    },
    {
        "Name": "Contig595",
        "Length": 16007
    },
    {
        "Name": "Contig596",
        "Length": 16006
    },
    {
        "Name": "Contig597",
        "Length": 16006
    },
    {
        "Name": "Contig598",
        "Length": 16005
    },
    {
        "Name": "Contig599",
        "Length": 15999
    },
    {
        "Name": "Contig600",
        "Length": 15997
    },
    {
        "Name": "Contig601",
        "Length": 15996
    },
    {
        "Name": "Contig602",
        "Length": 15994
    },
    {
        "Name": "Contig603",
        "Length": 15993
    },
    {
        "Name": "Contig604",
        "Length": 15992
    },
    {
        "Name": "Contig605",
        "Length": 15992
    },
    {
        "Name": "Contig606",
        "Length": 15991
    },
    {
        "Name": "Contig607",
        "Length": 15990
    },
    {
        "Name": "Contig608",
        "Length": 15988
    },
    {
        "Name": "Contig609",
        "Length": 15988
    },
    {
        "Name": "Contig610",
        "Length": 15988
    },
    {
        "Name": "Contig611",
        "Length": 15988
    },
    {
        "Name": "Contig612",
        "Length": 15988
    },
    {
        "Name": "Contig613",
        "Length": 15988
    },
    {
        "Name": "Contig614",
        "Length": 15988
    },
    {
        "Name": "Contig615",
        "Length": 15988
    },
    {
        "Name": "Contig616",
        "Length": 15665
    },
    {
        "Name": "Contig617",
        "Length": 15434
    },
    {
        "Name": "Contig618",
        "Length": 15432
    },
    {
        "Name": "Contig619",
        "Length": 15253
    },
    {
        "Name": "Contig620",
        "Length": 15252
    },
    {
        "Name": "Contig621",
        "Length": 15216
    },
    {
        "Name": "Contig622",
        "Length": 15155
    },
    {
        "Name": "Contig623",
        "Length": 15129
    },
    {
        "Name": "Contig624",
        "Length": 15091
    },
    {
        "Name": "Contig625",
        "Length": 15061
    },
    {
        "Name": "Contig626",
        "Length": 15053
    },
    {
        "Name": "Contig627",
        "Length": 15053
    },
    {
        "Name": "Contig628",
        "Length": 15032
    },
    {
        "Name": "Contig629",
        "Length": 15027
    },
    {
        "Name": "Contig630",
        "Length": 15026
    },
    {
        "Name": "Contig631",
        "Length": 15025
    },
    {
        "Name": "Contig632",
        "Length": 15012
    },
    {
        "Name": "Contig633",
        "Length": 15009
    },
    {
        "Name": "Contig634",
        "Length": 15008
    },
    {
        "Name": "Contig635",
        "Length": 15008
    },
    {
        "Name": "Contig636",
        "Length": 15008
    },
    {
        "Name": "Contig637",
        "Length": 15005
    },
    {
        "Name": "Contig638",
        "Length": 15003
    },
    {
        "Name": "Contig639",
        "Length": 14997
    },
    {
        "Name": "Contig640",
        "Length": 14997
    },
    {
        "Name": "Contig641",
        "Length": 14997
    },
    {
        "Name": "Contig642",
        "Length": 14996
    },
    {
        "Name": "Contig643",
        "Length": 14996
    },
    {
        "Name": "Contig644",
        "Length": 14996
    },
    {
        "Name": "Contig645",
        "Length": 14995
    },
    {
        "Name": "Contig646",
        "Length": 14995
    },
    {
        "Name": "Contig647",
        "Length": 14993
    },
    {
        "Name": "Contig648",
        "Length": 14992
    },
    {
        "Name": "Contig649",
        "Length": 14991
    },
    {
        "Name": "Contig650",
        "Length": 14990
    },
    {
        "Name": "Contig651",
        "Length": 14990
    },
    {
        "Name": "Contig652",
        "Length": 14989
    },
    {
        "Name": "Contig653",
        "Length": 14989
    },
    {
        "Name": "Contig654",
        "Length": 14989
    },
    {
        "Name": "Contig655",
        "Length": 14989
    },
    {
        "Name": "Contig656",
        "Length": 14988
    },
    {
        "Name": "Contig657",
        "Length": 14988
    },
    {
        "Name": "Contig658",
        "Length": 14988
    },
    {
        "Name": "Contig659",
        "Length": 14683
    },
    {
        "Name": "Contig660",
        "Length": 14601
    },
    {
        "Name": "Contig661",
        "Length": 14286
    },
    {
        "Name": "Contig662",
        "Length": 14273
    },
    {
        "Name": "Contig663",
        "Length": 14240
    },
    {
        "Name": "Contig664",
        "Length": 14227
    },
    {
        "Name": "Contig665",
        "Length": 14217
    },
    {
        "Name": "Contig666",
        "Length": 14183
    },
    {
        "Name": "Contig667",
        "Length": 14167
    },
    {
        "Name": "Contig668",
        "Length": 14133
    },
    {
        "Name": "Contig669",
        "Length": 14125
    },
    {
        "Name": "Contig670",
        "Length": 14113
    },
    {
        "Name": "Contig671",
        "Length": 14077
    },
    {
        "Name": "Contig672",
        "Length": 14064
    },
    {
        "Name": "Contig673",
        "Length": 14061
    },
    {
        "Name": "Contig674",
        "Length": 14039
    },
    {
        "Name": "Contig675",
        "Length": 14039
    },
    {
        "Name": "Contig676",
        "Length": 14037
    },
    {
        "Name": "Contig677",
        "Length": 14033
    },
    {
        "Name": "Contig678",
        "Length": 14031
    },
    {
        "Name": "Contig679",
        "Length": 14027
    },
    {
        "Name": "Contig680",
        "Length": 14026
    },
    {
        "Name": "Contig681",
        "Length": 14025
    },
    {
        "Name": "Contig682",
        "Length": 14024
    },
    {
        "Name": "Contig683",
        "Length": 14024
    },
    {
        "Name": "Contig684",
        "Length": 14023
    },
    {
        "Name": "Contig685",
        "Length": 14023
    },
    {
        "Name": "Contig686",
        "Length": 14023
    },
    {
        "Name": "Contig687",
        "Length": 14021
    },
    {
        "Name": "Contig688",
        "Length": 14017
    },
    {
        "Name": "Contig689",
        "Length": 14017
    },
    {
        "Name": "Contig690",
        "Length": 14017
    },
    {
        "Name": "Contig691",
        "Length": 14015
    },
    {
        "Name": "Contig692",
        "Length": 14011
    },
    {
        "Name": "Contig693",
        "Length": 14009
    },
    {
        "Name": "Contig694",
        "Length": 14006
    },
    {
        "Name": "Contig695",
        "Length": 14005
    },
    {
        "Name": "Contig696",
        "Length": 14003
    },
    {
        "Name": "Contig697",
        "Length": 14002
    },
    {
        "Name": "Contig698",
        "Length": 14001
    },
    {
        "Name": "Contig699",
        "Length": 14000
    },
    {
        "Name": "Contig700",
        "Length": 13997
    },
    {
        "Name": "Contig701",
        "Length": 13994
    },
    {
        "Name": "Contig702",
        "Length": 13991
    },
    {
        "Name": "Contig703",
        "Length": 13989
    },
    {
        "Name": "Contig704",
        "Length": 13989
    },
    {
        "Name": "Contig705",
        "Length": 13989
    },
    {
        "Name": "Contig706",
        "Length": 13988
    },
    {
        "Name": "Contig707",
        "Length": 13988
    },
    {
        "Name": "Contig708",
        "Length": 13988
    },
    {
        "Name": "Contig709",
        "Length": 13988
    },
    {
        "Name": "Contig710",
        "Length": 13988
    },
    {
        "Name": "Contig711",
        "Length": 13988
    },
    {
        "Name": "Contig712",
        "Length": 13988
    },
    {
        "Name": "Contig713",
        "Length": 13973
    },
    {
        "Name": "Contig714",
        "Length": 13647
    },
    {
        "Name": "Contig715",
        "Length": 13539
    },
    {
        "Name": "Contig716",
        "Length": 13245
    },
    {
        "Name": "Contig717",
        "Length": 13229
    },
    {
        "Name": "Contig718",
        "Length": 13207
    },
    {
        "Name": "Contig719",
        "Length": 13185
    },
    {
        "Name": "Contig720",
        "Length": 13160
    },
    {
        "Name": "Contig721",
        "Length": 13125
    },
    {
        "Name": "Contig722",
        "Length": 13061
    },
    {
        "Name": "Contig723",
        "Length": 13053
    },
    {
        "Name": "Contig724",
        "Length": 13052
    },
    {
        "Name": "Contig725",
        "Length": 13047
    },
    {
        "Name": "Contig726",
        "Length": 13039
    },
    {
        "Name": "Contig727",
        "Length": 13038
    },
    {
        "Name": "Contig728",
        "Length": 13037
    },
    {
        "Name": "Contig729",
        "Length": 13037
    },
    {
        "Name": "Contig730",
        "Length": 13026
    },
    {
        "Name": "Contig731",
        "Length": 13025
    },
    {
        "Name": "Contig732",
        "Length": 13022
    },
    {
        "Name": "Contig733",
        "Length": 13017
    },
    {
        "Name": "Contig734",
        "Length": 13016
    },
    {
        "Name": "Contig735",
        "Length": 13014
    },
    {
        "Name": "Contig736",
        "Length": 13011
    },
    {
        "Name": "Contig737",
        "Length": 13009
    },
    {
        "Name": "Contig738",
        "Length": 13009
    },
    {
        "Name": "Contig739",
        "Length": 13009
    },
    {
        "Name": "Contig740",
        "Length": 13009
    },
    {
        "Name": "Contig741",
        "Length": 13005
    },
    {
        "Name": "Contig742",
        "Length": 13002
    },
    {
        "Name": "Contig743",
        "Length": 13002
    },
    {
        "Name": "Contig744",
        "Length": 13001
    },
    {
        "Name": "Contig745",
        "Length": 12999
    },
    {
        "Name": "Contig746",
        "Length": 12999
    },
    {
        "Name": "Contig747",
        "Length": 12999
    },
    {
        "Name": "Contig748",
        "Length": 12997
    },
    {
        "Name": "Contig749",
        "Length": 12996
    },
    {
        "Name": "Contig750",
        "Length": 12995
    },
    {
        "Name": "Contig751",
        "Length": 12990
    },
    {
        "Name": "Contig752",
        "Length": 12990
    },
    {
        "Name": "Contig753",
        "Length": 12988
    },
    {
        "Name": "Contig754",
        "Length": 12988
    },
    {
        "Name": "Contig755",
        "Length": 12988
    },
    {
        "Name": "Contig756",
        "Length": 12988
    },
    {
        "Name": "Contig757",
        "Length": 12988
    },
    {
        "Name": "Contig758",
        "Length": 12988
    },
    {
        "Name": "Contig759",
        "Length": 12668
    },
    {
        "Name": "Contig760",
        "Length": 12117
    },
    {
        "Name": "Contig761",
        "Length": 12046
    },
    {
        "Name": "Contig762",
        "Length": 12045
    },
    {
        "Name": "Contig763",
        "Length": 12044
    },
    {
        "Name": "Contig764",
        "Length": 12041
    },
    {
        "Name": "Contig765",
        "Length": 12032
    },
    {
        "Name": "Contig766",
        "Length": 12032
    },
    {
        "Name": "Contig767",
        "Length": 12031
    },
    {
        "Name": "Contig768",
        "Length": 12024
    },
    {
        "Name": "Contig769",
        "Length": 12021
    },
    {
        "Name": "Contig770",
        "Length": 12017
    },
    {
        "Name": "Contig771",
        "Length": 12015
    },
    {
        "Name": "Contig772",
        "Length": 12014
    },
    {
        "Name": "Contig773",
        "Length": 12014
    },
    {
        "Name": "Contig774",
        "Length": 12012
    },
    {
        "Name": "Contig775",
        "Length": 12012
    },
    {
        "Name": "Contig776",
        "Length": 12011
    },
    {
        "Name": "Contig777",
        "Length": 12009
    },
    {
        "Name": "Contig778",
        "Length": 12009
    },
    {
        "Name": "Contig779",
        "Length": 12009
    },
    {
        "Name": "Contig780",
        "Length": 12009
    },
    {
        "Name": "Contig781",
        "Length": 12008
    },
    {
        "Name": "Contig782",
        "Length": 12007
    },
    {
        "Name": "Contig783",
        "Length": 12006
    },
    {
        "Name": "Contig784",
        "Length": 12002
    },
    {
        "Name": "Contig785",
        "Length": 12001
    },
    {
        "Name": "Contig786",
        "Length": 12001
    },
    {
        "Name": "Contig787",
        "Length": 12001
    },
    {
        "Name": "Contig788",
        "Length": 12000
    },
    {
        "Name": "Contig789",
        "Length": 11999
    },
    {
        "Name": "Contig790",
        "Length": 11999
    },
    {
        "Name": "Contig791",
        "Length": 11999
    },
    {
        "Name": "Contig792",
        "Length": 11998
    },
    {
        "Name": "Contig793",
        "Length": 11997
    },
    {
        "Name": "Contig794",
        "Length": 11997
    },
    {
        "Name": "Contig795",
        "Length": 11997
    },
    {
        "Name": "Contig796",
        "Length": 11996
    },
    {
        "Name": "Contig797",
        "Length": 11996
    },
    {
        "Name": "Contig798",
        "Length": 11995
    },
    {
        "Name": "Contig799",
        "Length": 11995
    },
    {
        "Name": "Contig800",
        "Length": 11994
    },
    {
        "Name": "Contig801",
        "Length": 11993
    },
    {
        "Name": "Contig802",
        "Length": 11992
    },
    {
        "Name": "Contig803",
        "Length": 11992
    },
    {
        "Name": "Contig804",
        "Length": 11990
    },
    {
        "Name": "Contig805",
        "Length": 11989
    },
    {
        "Name": "Contig806",
        "Length": 11988
    },
    {
        "Name": "Contig807",
        "Length": 11988
    },
    {
        "Name": "Contig808",
        "Length": 11988
    },
    {
        "Name": "Contig809",
        "Length": 11988
    },
    {
        "Name": "Contig810",
        "Length": 11988
    },
    {
        "Name": "Contig811",
        "Length": 11988
    },
    {
        "Name": "Contig812",
        "Length": 11988
    },
    {
        "Name": "Contig813",
        "Length": 11988
    },
    {
        "Name": "Contig814",
        "Length": 11988
    },
    {
        "Name": "Contig815",
        "Length": 11988
    },
    {
        "Name": "Contig816",
        "Length": 11988
    },
    {
        "Name": "Contig817",
        "Length": 11988
    },
    {
        "Name": "Contig818",
        "Length": 11988
    },
    {
        "Name": "Contig819",
        "Length": 11621
    },
    {
        "Name": "Contig820",
        "Length": 11397
    },
    {
        "Name": "Contig821",
        "Length": 11348
    },
    {
        "Name": "Contig822",
        "Length": 11174
    },
    {
        "Name": "Contig823",
        "Length": 11137
    },
    {
        "Name": "Contig824",
        "Length": 11118
    },
    {
        "Name": "Contig825",
        "Length": 11109
    },
    {
        "Name": "Contig826",
        "Length": 11097
    },
    {
        "Name": "Contig827",
        "Length": 11093
    },
    {
        "Name": "Contig828",
        "Length": 11089
    },
    {
        "Name": "Contig829",
        "Length": 11080
    },
    {
        "Name": "Contig830",
        "Length": 11076
    },
    {
        "Name": "Contig831",
        "Length": 11066
    },
    {
        "Name": "Contig832",
        "Length": 11062
    },
    {
        "Name": "Contig833",
        "Length": 11057
    },
    {
        "Name": "Contig834",
        "Length": 11040
    },
    {
        "Name": "Contig835",
        "Length": 11040
    },
    {
        "Name": "Contig836",
        "Length": 11037
    },
    {
        "Name": "Contig837",
        "Length": 11037
    },
    {
        "Name": "Contig838",
        "Length": 11035
    },
    {
        "Name": "Contig839",
        "Length": 11034
    },
    {
        "Name": "Contig840",
        "Length": 11034
    },
    {
        "Name": "Contig841",
        "Length": 11026
    },
    {
        "Name": "Contig842",
        "Length": 11022
    },
    {
        "Name": "Contig843",
        "Length": 11021
    },
    {
        "Name": "Contig844",
        "Length": 11017
    },
    {
        "Name": "Contig845",
        "Length": 11016
    },
    {
        "Name": "Contig846",
        "Length": 11014
    },
    {
        "Name": "Contig847",
        "Length": 11012
    },
    {
        "Name": "Contig848",
        "Length": 11010
    },
    {
        "Name": "Contig849",
        "Length": 11009
    },
    {
        "Name": "Contig850",
        "Length": 11006
    },
    {
        "Name": "Contig851",
        "Length": 11006
    },
    {
        "Name": "Contig852",
        "Length": 11004
    },
    {
        "Name": "Contig853",
        "Length": 11004
    },
    {
        "Name": "Contig854",
        "Length": 11004
    },
    {
        "Name": "Contig855",
        "Length": 11002
    },
    {
        "Name": "Contig856",
        "Length": 11002
    },
    {
        "Name": "Contig857",
        "Length": 11000
    },
    {
        "Name": "Contig858",
        "Length": 10999
    },
    {
        "Name": "Contig859",
        "Length": 10999
    },
    {
        "Name": "Contig860",
        "Length": 10997
    },
    {
        "Name": "Contig861",
        "Length": 10997
    },
    {
        "Name": "Contig862",
        "Length": 10996
    },
    {
        "Name": "Contig863",
        "Length": 10996
    },
    {
        "Name": "Contig864",
        "Length": 10996
    },
    {
        "Name": "Contig865",
        "Length": 10995
    },
    {
        "Name": "Contig866",
        "Length": 10994
    },
    {
        "Name": "Contig867",
        "Length": 10994
    },
    {
        "Name": "Contig868",
        "Length": 10994
    },
    {
        "Name": "Contig869",
        "Length": 10993
    },
    {
        "Name": "Contig870",
        "Length": 10992
    },
    {
        "Name": "Contig871",
        "Length": 10992
    },
    {
        "Name": "Contig872",
        "Length": 10992
    },
    {
        "Name": "Contig873",
        "Length": 10991
    },
    {
        "Name": "Contig874",
        "Length": 10990
    },
    {
        "Name": "Contig875",
        "Length": 10990
    },
    {
        "Name": "Contig876",
        "Length": 10989
    },
    {
        "Name": "Contig877",
        "Length": 10989
    },
    {
        "Name": "Contig878",
        "Length": 10989
    },
    {
        "Name": "Contig879",
        "Length": 10988
    },
    {
        "Name": "Contig880",
        "Length": 10988
    },
    {
        "Name": "Contig881",
        "Length": 10988
    },
    {
        "Name": "Contig882",
        "Length": 10988
    },
    {
        "Name": "Contig883",
        "Length": 10988
    },
    {
        "Name": "Contig884",
        "Length": 10988
    },
    {
        "Name": "Contig885",
        "Length": 10988
    },
    {
        "Name": "Contig886",
        "Length": 10988
    },
    {
        "Name": "Contig887",
        "Length": 10988
    },
    {
        "Name": "Contig888",
        "Length": 10988
    },
    {
        "Name": "Contig889",
        "Length": 10988
    },
    {
        "Name": "Contig890",
        "Length": 10980
    },
    {
        "Name": "Contig891",
        "Length": 10462
    },
    {
        "Name": "Contig892",
        "Length": 10408
    },
    {
        "Name": "Contig893",
        "Length": 10233
    },
    {
        "Name": "Contig894",
        "Length": 10156
    },
    {
        "Name": "Contig895",
        "Length": 10128
    },
    {
        "Name": "Contig896",
        "Length": 10117
    },
    {
        "Name": "Contig897",
        "Length": 10095
    },
    {
        "Name": "Contig898",
        "Length": 10095
    },
    {
        "Name": "Contig899",
        "Length": 10088
    },
    {
        "Name": "Contig900",
        "Length": 10086
    },
    {
        "Name": "Contig901",
        "Length": 10075
    },
    {
        "Name": "Contig902",
        "Length": 10065
    },
    {
        "Name": "Contig903",
        "Length": 10059
    },
    {
        "Name": "Contig904",
        "Length": 10059
    },
    {
        "Name": "Contig905",
        "Length": 10056
    },
    {
        "Name": "Contig906",
        "Length": 10050
    },
    {
        "Name": "Contig907",
        "Length": 10049
    },
    {
        "Name": "Contig908",
        "Length": 10046
    },
    {
        "Name": "Contig909",
        "Length": 10038
    },
    {
        "Name": "Contig910",
        "Length": 10037
    },
    {
        "Name": "Contig911",
        "Length": 10033
    },
    {
        "Name": "Contig912",
        "Length": 10029
    },
    {
        "Name": "Contig913",
        "Length": 10029
    },
    {
        "Name": "Contig914",
        "Length": 10029
    },
    {
        "Name": "Contig915",
        "Length": 10028
    },
    {
        "Name": "Contig916",
        "Length": 10027
    },
    {
        "Name": "Contig917",
        "Length": 10026
    },
    {
        "Name": "Contig918",
        "Length": 10024
    },
    {
        "Name": "Contig919",
        "Length": 10019
    },
    {
        "Name": "Contig920",
        "Length": 10019
    },
    {
        "Name": "Contig921",
        "Length": 10017
    },
    {
        "Name": "Contig922",
        "Length": 10017
    },
    {
        "Name": "Contig923",
        "Length": 10012
    },
    {
        "Name": "Contig924",
        "Length": 10010
    },
    {
        "Name": "Contig925",
        "Length": 10010
    },
    {
        "Name": "Contig926",
        "Length": 10009
    },
    {
        "Name": "Contig927",
        "Length": 10007
    },
    {
        "Name": "Contig928",
        "Length": 10006
    },
    {
        "Name": "Contig929",
        "Length": 10005
    },
    {
        "Name": "Contig930",
        "Length": 10005
    },
    {
        "Name": "Contig931",
        "Length": 10005
    },
    {
        "Name": "Contig932",
        "Length": 10005
    },
    {
        "Name": "Contig933",
        "Length": 10002
    },
    {
        "Name": "Contig934",
        "Length": 10001
    },
    {
        "Name": "Contig935",
        "Length": 10001
    },
    {
        "Name": "Contig936",
        "Length": 10000
    },
    {
        "Name": "Contig937",
        "Length": 9999
    },
    {
        "Name": "Contig938",
        "Length": 9999
    },
    {
        "Name": "Contig939",
        "Length": 9998
    },
    {
        "Name": "Contig940",
        "Length": 9997
    },
    {
        "Name": "Contig941",
        "Length": 9997
    },
    {
        "Name": "Contig942",
        "Length": 9997
    },
    {
        "Name": "Contig943",
        "Length": 9996
    },
    {
        "Name": "Contig944",
        "Length": 9996
    },
    {
        "Name": "Contig945",
        "Length": 9996
    },
    {
        "Name": "Contig946",
        "Length": 9996
    },
    {
        "Name": "Contig947",
        "Length": 9996
    },
    {
        "Name": "Contig948",
        "Length": 9995
    },
    {
        "Name": "Contig949",
        "Length": 9994
    },
    {
        "Name": "Contig950",
        "Length": 9994
    },
    {
        "Name": "Contig951",
        "Length": 9994
    },
    {
        "Name": "Contig952",
        "Length": 9994
    },
    {
        "Name": "Contig953",
        "Length": 9994
    },
    {
        "Name": "Contig954",
        "Length": 9993
    },
    {
        "Name": "Contig955",
        "Length": 9993
    },
    {
        "Name": "Contig956",
        "Length": 9992
    },
    {
        "Name": "Contig957",
        "Length": 9992
    },
    {
        "Name": "Contig958",
        "Length": 9992
    },
    {
        "Name": "Contig959",
        "Length": 9992
    },
    {
        "Name": "Contig960",
        "Length": 9991
    },
    {
        "Name": "Contig961",
        "Length": 9991
    },
    {
        "Name": "Contig962",
        "Length": 9989
    },
    {
        "Name": "Contig963",
        "Length": 9989
    },
    {
        "Name": "Contig964",
        "Length": 9989
    },
    {
        "Name": "Contig965",
        "Length": 9989
    },
    {
        "Name": "Contig966",
        "Length": 9989
    },
    {
        "Name": "Contig967",
        "Length": 9988
    },
    {
        "Name": "Contig968",
        "Length": 9988
    },
    {
        "Name": "Contig969",
        "Length": 9988
    },
    {
        "Name": "Contig970",
        "Length": 9988
    },
    {
        "Name": "Contig971",
        "Length": 9988
    },
    {
        "Name": "Contig972",
        "Length": 9988
    },
    {
        "Name": "Contig973",
        "Length": 9988
    },
    {
        "Name": "Contig974",
        "Length": 9988
    },
    {
        "Name": "Contig975",
        "Length": 9988
    },
    {
        "Name": "Contig976",
        "Length": 9988
    },
    {
        "Name": "Contig977",
        "Length": 9988
    },
    {
        "Name": "Contig978",
        "Length": 9988
    },
    {
        "Name": "Contig979",
        "Length": 9988
    },
    {
        "Name": "Contig980",
        "Length": 9988
    },
    {
        "Name": "Contig981",
        "Length": 9988
    },
    {
        "Name": "Contig982",
        "Length": 9988
    },
    {
        "Name": "Contig983",
        "Length": 9988
    },
    {
        "Name": "Contig984",
        "Length": 9988
    },
    {
        "Name": "Contig985",
        "Length": 9988
    },
    {
        "Name": "Contig986",
        "Length": 9988
    },
    {
        "Name": "Contig987",
        "Length": 9988
    },
    {
        "Name": "Contig988",
        "Length": 9988
    },
    {
        "Name": "Contig989",
        "Length": 9988
    },
    {
        "Name": "Contig990",
        "Length": 9988
    },
    {
        "Name": "Contig991",
        "Length": 9988
    },
    {
        "Name": "Contig992",
        "Length": 9261
    },
    {
        "Name": "Contig993",
        "Length": 9243
    },
    {
        "Name": "Contig994",
        "Length": 9208
    },
    {
        "Name": "Contig995",
        "Length": 9187
    },
    {
        "Name": "Contig996",
        "Length": 9134
    },
    {
        "Name": "Contig997",
        "Length": 9128
    },
    {
        "Name": "Contig998",
        "Length": 9128
    },
    {
        "Name": "Contig999",
        "Length": 9123
    },
    {
        "Name": "Contig1000",
        "Length": 9107
    },
    {
        "Name": "Contig1001",
        "Length": 9081
    },
    {
        "Name": "Contig1002",
        "Length": 9076
    },
    {
        "Name": "Contig1003",
        "Length": 9072
    },
    {
        "Name": "Contig1004",
        "Length": 9066
    },
    {
        "Name": "Contig1005",
        "Length": 9058
    },
    {
        "Name": "Contig1006",
        "Length": 9057
    },
    {
        "Name": "Contig1007",
        "Length": 9054
    },
    {
        "Name": "Contig1008",
        "Length": 9053
    },
    {
        "Name": "Contig1009",
        "Length": 9048
    },
    {
        "Name": "Contig1010",
        "Length": 9036
    },
    {
        "Name": "Contig1011",
        "Length": 9034
    },
    {
        "Name": "Contig1012",
        "Length": 9031
    },
    {
        "Name": "Contig1013",
        "Length": 9029
    },
    {
        "Name": "Contig1014",
        "Length": 9026
    },
    {
        "Name": "Contig1015",
        "Length": 9024
    },
    {
        "Name": "Contig1016",
        "Length": 9022
    },
    {
        "Name": "Contig1017",
        "Length": 9020
    },
    {
        "Name": "Contig1018",
        "Length": 9019
    },
    {
        "Name": "Contig1019",
        "Length": 9018
    },
    {
        "Name": "Contig1020",
        "Length": 9017
    },
    {
        "Name": "Contig1021",
        "Length": 9015
    },
    {
        "Name": "Contig1022",
        "Length": 9012
    },
    {
        "Name": "Contig1023",
        "Length": 9009
    },
    {
        "Name": "Contig1024",
        "Length": 9009
    },
    {
        "Name": "Contig1025",
        "Length": 9008
    },
    {
        "Name": "Contig1026",
        "Length": 9008
    },
    {
        "Name": "Contig1027",
        "Length": 9006
    },
    {
        "Name": "Contig1028",
        "Length": 9006
    },
    {
        "Name": "Contig1029",
        "Length": 9005
    },
    {
        "Name": "Contig1030",
        "Length": 9005
    },
    {
        "Name": "Contig1031",
        "Length": 9005
    },
    {
        "Name": "Contig1032",
        "Length": 9004
    },
    {
        "Name": "Contig1033",
        "Length": 9004
    },
    {
        "Name": "Contig1034",
        "Length": 9003
    },
    {
        "Name": "Contig1035",
        "Length": 9003
    },
    {
        "Name": "Contig1036",
        "Length": 9002
    },
    {
        "Name": "Contig1037",
        "Length": 9001
    },
    {
        "Name": "Contig1038",
        "Length": 9001
    },
    {
        "Name": "Contig1039",
        "Length": 9000
    },
    {
        "Name": "Contig1040",
        "Length": 8999
    },
    {
        "Name": "Contig1041",
        "Length": 8998
    },
    {
        "Name": "Contig1042",
        "Length": 8998
    },
    {
        "Name": "Contig1043",
        "Length": 8998
    },
    {
        "Name": "Contig1044",
        "Length": 8998
    },
    {
        "Name": "Contig1045",
        "Length": 8996
    },
    {
        "Name": "Contig1046",
        "Length": 8996
    },
    {
        "Name": "Contig1047",
        "Length": 8996
    },
    {
        "Name": "Contig1048",
        "Length": 8996
    },
    {
        "Name": "Contig1049",
        "Length": 8995
    },
    {
        "Name": "Contig1050",
        "Length": 8995
    },
    {
        "Name": "Contig1051",
        "Length": 8994
    },
    {
        "Name": "Contig1052",
        "Length": 8993
    },
    {
        "Name": "Contig1053",
        "Length": 8993
    },
    {
        "Name": "Contig1054",
        "Length": 8993
    },
    {
        "Name": "Contig1055",
        "Length": 8993
    },
    {
        "Name": "Contig1056",
        "Length": 8993
    },
    {
        "Name": "Contig1057",
        "Length": 8993
    },
    {
        "Name": "Contig1058",
        "Length": 8991
    },
    {
        "Name": "Contig1059",
        "Length": 8991
    },
    {
        "Name": "Contig1060",
        "Length": 8991
    },
    {
        "Name": "Contig1061",
        "Length": 8991
    },
    {
        "Name": "Contig1062",
        "Length": 8990
    },
    {
        "Name": "Contig1063",
        "Length": 8990
    },
    {
        "Name": "Contig1064",
        "Length": 8990
    },
    {
        "Name": "Contig1065",
        "Length": 8990
    },
    {
        "Name": "Contig1066",
        "Length": 8990
    },
    {
        "Name": "Contig1067",
        "Length": 8989
    },
    {
        "Name": "Contig1068",
        "Length": 8989
    },
    {
        "Name": "Contig1069",
        "Length": 8989
    },
    {
        "Name": "Contig1070",
        "Length": 8988
    },
    {
        "Name": "Contig1071",
        "Length": 8988
    },
    {
        "Name": "Contig1072",
        "Length": 8988
    },
    {
        "Name": "Contig1073",
        "Length": 8988
    },
    {
        "Name": "Contig1074",
        "Length": 8988
    },
    {
        "Name": "Contig1075",
        "Length": 8988
    },
    {
        "Name": "Contig1076",
        "Length": 8988
    },
    {
        "Name": "Contig1077",
        "Length": 8988
    },
    {
        "Name": "Contig1078",
        "Length": 8988
    },
    {
        "Name": "Contig1079",
        "Length": 8988
    },
    {
        "Name": "Contig1080",
        "Length": 8988
    },
    {
        "Name": "Contig1081",
        "Length": 8988
    },
    {
        "Name": "Contig1082",
        "Length": 8988
    },
    {
        "Name": "Contig1083",
        "Length": 8988
    },
    {
        "Name": "Contig1084",
        "Length": 8988
    },
    {
        "Name": "Contig1085",
        "Length": 8988
    },
    {
        "Name": "Contig1086",
        "Length": 8988
    },
    {
        "Name": "Contig1087",
        "Length": 8988
    },
    {
        "Name": "Contig1088",
        "Length": 8988
    },
    {
        "Name": "Contig1089",
        "Length": 8988
    },
    {
        "Name": "Contig1090",
        "Length": 8988
    },
    {
        "Name": "Contig1091",
        "Length": 8988
    },
    {
        "Name": "Contig1092",
        "Length": 8988
    },
    {
        "Name": "Contig1093",
        "Length": 8986
    },
    {
        "Name": "Contig1094",
        "Length": 8841
    },
    {
        "Name": "Contig1095",
        "Length": 8688
    },
    {
        "Name": "Contig1096",
        "Length": 8141
    },
    {
        "Name": "Contig1097",
        "Length": 8113
    },
    {
        "Name": "Contig1098",
        "Length": 8107
    },
    {
        "Name": "Contig1099",
        "Length": 8085
    },
    {
        "Name": "Contig1100",
        "Length": 8080
    },
    {
        "Name": "Contig1101",
        "Length": 8076
    },
    {
        "Name": "Contig1102",
        "Length": 8058
    },
    {
        "Name": "Contig1103",
        "Length": 8039
    },
    {
        "Name": "Contig1104",
        "Length": 8038
    },
    {
        "Name": "Contig1105",
        "Length": 8038
    },
    {
        "Name": "Contig1106",
        "Length": 8030
    },
    {
        "Name": "Contig1107",
        "Length": 8028
    },
    {
        "Name": "Contig1108",
        "Length": 8027
    },
    {
        "Name": "Contig1109",
        "Length": 8024
    },
    {
        "Name": "Contig1110",
        "Length": 8023
    },
    {
        "Name": "Contig1111",
        "Length": 8019
    },
    {
        "Name": "Contig1112",
        "Length": 8014
    },
    {
        "Name": "Contig1113",
        "Length": 8013
    },
    {
        "Name": "Contig1114",
        "Length": 8013
    },
    {
        "Name": "Contig1115",
        "Length": 8013
    },
    {
        "Name": "Contig1116",
        "Length": 8012
    },
    {
        "Name": "Contig1117",
        "Length": 8009
    },
    {
        "Name": "Contig1118",
        "Length": 8009
    },
    {
        "Name": "Contig1119",
        "Length": 8008
    },
    {
        "Name": "Contig1120",
        "Length": 8007
    },
    {
        "Name": "Contig1121",
        "Length": 8007
    },
    {
        "Name": "Contig1122",
        "Length": 8006
    },
    {
        "Name": "Contig1123",
        "Length": 8005
    },
    {
        "Name": "Contig1124",
        "Length": 8003
    },
    {
        "Name": "Contig1125",
        "Length": 8001
    },
    {
        "Name": "Contig1126",
        "Length": 8001
    },
    {
        "Name": "Contig1127",
        "Length": 8000
    },
    {
        "Name": "Contig1128",
        "Length": 7999
    },
    {
        "Name": "Contig1129",
        "Length": 7999
    },
    {
        "Name": "Contig1130",
        "Length": 7998
    },
    {
        "Name": "Contig1131",
        "Length": 7998
    },
    {
        "Name": "Contig1132",
        "Length": 7998
    },
    {
        "Name": "Contig1133",
        "Length": 7998
    },
    {
        "Name": "Contig1134",
        "Length": 7997
    },
    {
        "Name": "Contig1135",
        "Length": 7996
    },
    {
        "Name": "Contig1136",
        "Length": 7996
    },
    {
        "Name": "Contig1137",
        "Length": 7996
    },
    {
        "Name": "Contig1138",
        "Length": 7995
    },
    {
        "Name": "Contig1139",
        "Length": 7995
    },
    {
        "Name": "Contig1140",
        "Length": 7994
    },
    {
        "Name": "Contig1141",
        "Length": 7994
    },
    {
        "Name": "Contig1142",
        "Length": 7994
    },
    {
        "Name": "Contig1143",
        "Length": 7994
    },
    {
        "Name": "Contig1144",
        "Length": 7993
    },
    {
        "Name": "Contig1145",
        "Length": 7993
    },
    {
        "Name": "Contig1146",
        "Length": 7992
    },
    {
        "Name": "Contig1147",
        "Length": 7991
    },
    {
        "Name": "Contig1148",
        "Length": 7991
    },
    {
        "Name": "Contig1149",
        "Length": 7991
    },
    {
        "Name": "Contig1150",
        "Length": 7991
    },
    {
        "Name": "Contig1151",
        "Length": 7991
    },
    {
        "Name": "Contig1152",
        "Length": 7991
    },
    {
        "Name": "Contig1153",
        "Length": 7991
    },
    {
        "Name": "Contig1154",
        "Length": 7991
    },
    {
        "Name": "Contig1155",
        "Length": 7991
    },
    {
        "Name": "Contig1156",
        "Length": 7991
    },
    {
        "Name": "Contig1157",
        "Length": 7990
    },
    {
        "Name": "Contig1158",
        "Length": 7990
    },
    {
        "Name": "Contig1159",
        "Length": 7990
    },
    {
        "Name": "Contig1160",
        "Length": 7989
    },
    {
        "Name": "Contig1161",
        "Length": 7989
    },
    {
        "Name": "Contig1162",
        "Length": 7989
    },
    {
        "Name": "Contig1163",
        "Length": 7989
    },
    {
        "Name": "Contig1164",
        "Length": 7989
    },
    {
        "Name": "Contig1165",
        "Length": 7989
    },
    {
        "Name": "Contig1166",
        "Length": 7989
    },
    {
        "Name": "Contig1167",
        "Length": 7989
    },
    {
        "Name": "Contig1168",
        "Length": 7989
    },
    {
        "Name": "Contig1169",
        "Length": 7989
    },
    {
        "Name": "Contig1170",
        "Length": 7989
    },
    {
        "Name": "Contig1171",
        "Length": 7988
    },
    {
        "Name": "Contig1172",
        "Length": 7988
    },
    {
        "Name": "Contig1173",
        "Length": 7988
    },
    {
        "Name": "Contig1174",
        "Length": 7988
    },
    {
        "Name": "Contig1175",
        "Length": 7988
    },
    {
        "Name": "Contig1176",
        "Length": 7988
    },
    {
        "Name": "Contig1177",
        "Length": 7988
    },
    {
        "Name": "Contig1178",
        "Length": 7988
    },
    {
        "Name": "Contig1179",
        "Length": 7988
    },
    {
        "Name": "Contig1180",
        "Length": 7988
    },
    {
        "Name": "Contig1181",
        "Length": 7988
    },
    {
        "Name": "Contig1182",
        "Length": 7988
    },
    {
        "Name": "Contig1183",
        "Length": 7988
    },
    {
        "Name": "Contig1184",
        "Length": 7988
    },
    {
        "Name": "Contig1185",
        "Length": 7988
    },
    {
        "Name": "Contig1186",
        "Length": 7988
    },
    {
        "Name": "Contig1187",
        "Length": 7988
    },
    {
        "Name": "Contig1188",
        "Length": 7988
    },
    {
        "Name": "Contig1189",
        "Length": 7988
    },
    {
        "Name": "Contig1190",
        "Length": 7988
    },
    {
        "Name": "Contig1191",
        "Length": 7988
    },
    {
        "Name": "Contig1192",
        "Length": 7988
    },
    {
        "Name": "Contig1193",
        "Length": 7988
    },
    {
        "Name": "Contig1194",
        "Length": 7988
    },
    {
        "Name": "Contig1195",
        "Length": 7988
    },
    {
        "Name": "Contig1196",
        "Length": 7988
    },
    {
        "Name": "Contig1197",
        "Length": 7988
    },
    {
        "Name": "Contig1198",
        "Length": 7988
    },
    {
        "Name": "Contig1199",
        "Length": 7968
    },
    {
        "Name": "Contig1200",
        "Length": 7507
    },
    {
        "Name": "Contig1201",
        "Length": 7504
    },
    {
        "Name": "Contig1202",
        "Length": 7412
    },
    {
        "Name": "Contig1203",
        "Length": 7286
    },
    {
        "Name": "Contig1204",
        "Length": 7191
    },
    {
        "Name": "Contig1205",
        "Length": 7127
    },
    {
        "Name": "Contig1206",
        "Length": 7112
    },
    {
        "Name": "Contig1207",
        "Length": 7069
    },
    {
        "Name": "Contig1208",
        "Length": 7068
    },
    {
        "Name": "Contig1209",
        "Length": 7067
    },
    {
        "Name": "Contig1210",
        "Length": 7058
    },
    {
        "Name": "Contig1211",
        "Length": 7055
    },
    {
        "Name": "Contig1212",
        "Length": 7034
    },
    {
        "Name": "Contig1213",
        "Length": 7032
    },
    {
        "Name": "Contig1214",
        "Length": 7032
    },
    {
        "Name": "Contig1215",
        "Length": 7028
    },
    {
        "Name": "Contig1216",
        "Length": 7025
    },
    {
        "Name": "Contig1217",
        "Length": 7023
    },
    {
        "Name": "Contig1218",
        "Length": 7022
    },
    {
        "Name": "Contig1219",
        "Length": 7017
    },
    {
        "Name": "Contig1220",
        "Length": 7015
    },
    {
        "Name": "Contig1221",
        "Length": 7011
    },
    {
        "Name": "Contig1222",
        "Length": 7010
    },
    {
        "Name": "Contig1223",
        "Length": 7009
    },
    {
        "Name": "Contig1224",
        "Length": 7009
    },
    {
        "Name": "Contig1225",
        "Length": 7008
    },
    {
        "Name": "Contig1226",
        "Length": 7007
    },
    {
        "Name": "Contig1227",
        "Length": 7007
    },
    {
        "Name": "Contig1228",
        "Length": 7007
    },
    {
        "Name": "Contig1229",
        "Length": 7006
    },
    {
        "Name": "Contig1230",
        "Length": 7006
    },
    {
        "Name": "Contig1231",
        "Length": 7005
    },
    {
        "Name": "Contig1232",
        "Length": 7004
    },
    {
        "Name": "Contig1233",
        "Length": 7003
    },
    {
        "Name": "Contig1234",
        "Length": 7003
    },
    {
        "Name": "Contig1235",
        "Length": 7002
    },
    {
        "Name": "Contig1236",
        "Length": 7001
    },
    {
        "Name": "Contig1237",
        "Length": 7001
    },
    {
        "Name": "Contig1238",
        "Length": 7001
    },
    {
        "Name": "Contig1239",
        "Length": 7001
    },
    {
        "Name": "Contig1240",
        "Length": 7001
    },
    {
        "Name": "Contig1241",
        "Length": 7000
    },
    {
        "Name": "Contig1242",
        "Length": 7000
    },
    {
        "Name": "Contig1243",
        "Length": 7000
    },
    {
        "Name": "Contig1244",
        "Length": 7000
    },
    {
        "Name": "Contig1245",
        "Length": 6999
    },
    {
        "Name": "Contig1246",
        "Length": 6999
    },
    {
        "Name": "Contig1247",
        "Length": 6998
    },
    {
        "Name": "Contig1248",
        "Length": 6998
    },
    {
        "Name": "Contig1249",
        "Length": 6998
    },
    {
        "Name": "Contig1250",
        "Length": 6997
    },
    {
        "Name": "Contig1251",
        "Length": 6997
    },
    {
        "Name": "Contig1252",
        "Length": 6997
    },
    {
        "Name": "Contig1253",
        "Length": 6997
    },
    {
        "Name": "Contig1254",
        "Length": 6996
    },
    {
        "Name": "Contig1255",
        "Length": 6996
    },
    {
        "Name": "Contig1256",
        "Length": 6995
    },
    {
        "Name": "Contig1257",
        "Length": 6995
    },
    {
        "Name": "Contig1258",
        "Length": 6995
    },
    {
        "Name": "Contig1259",
        "Length": 6995
    },
    {
        "Name": "Contig1260",
        "Length": 6994
    },
    {
        "Name": "Contig1261",
        "Length": 6994
    },
    {
        "Name": "Contig1262",
        "Length": 6994
    },
    {
        "Name": "Contig1263",
        "Length": 6994
    },
    {
        "Name": "Contig1264",
        "Length": 6994
    },
    {
        "Name": "Contig1265",
        "Length": 6994
    },
    {
        "Name": "Contig1266",
        "Length": 6993
    },
    {
        "Name": "Contig1267",
        "Length": 6993
    },
    {
        "Name": "Contig1268",
        "Length": 6993
    },
    {
        "Name": "Contig1269",
        "Length": 6992
    },
    {
        "Name": "Contig1270",
        "Length": 6992
    },
    {
        "Name": "Contig1271",
        "Length": 6992
    },
    {
        "Name": "Contig1272",
        "Length": 6992
    },
    {
        "Name": "Contig1273",
        "Length": 6992
    },
    {
        "Name": "Contig1274",
        "Length": 6991
    },
    {
        "Name": "Contig1275",
        "Length": 6991
    },
    {
        "Name": "Contig1276",
        "Length": 6991
    },
    {
        "Name": "Contig1277",
        "Length": 6991
    },
    {
        "Name": "Contig1278",
        "Length": 6991
    },
    {
        "Name": "Contig1279",
        "Length": 6990
    },
    {
        "Name": "Contig1280",
        "Length": 6990
    },
    {
        "Name": "Contig1281",
        "Length": 6990
    },
    {
        "Name": "Contig1282",
        "Length": 6990
    },
    {
        "Name": "Contig1283",
        "Length": 6989
    },
    {
        "Name": "Contig1284",
        "Length": 6989
    },
    {
        "Name": "Contig1285",
        "Length": 6989
    },
    {
        "Name": "Contig1286",
        "Length": 6989
    },
    {
        "Name": "Contig1287",
        "Length": 6989
    },
    {
        "Name": "Contig1288",
        "Length": 6989
    },
    {
        "Name": "Contig1289",
        "Length": 6989
    },
    {
        "Name": "Contig1290",
        "Length": 6989
    },
    {
        "Name": "Contig1291",
        "Length": 6989
    },
    {
        "Name": "Contig1292",
        "Length": 6989
    },
    {
        "Name": "Contig1293",
        "Length": 6989
    },
    {
        "Name": "Contig1294",
        "Length": 6988
    },
    {
        "Name": "Contig1295",
        "Length": 6988
    },
    {
        "Name": "Contig1296",
        "Length": 6988
    },
    {
        "Name": "Contig1297",
        "Length": 6988
    },
    {
        "Name": "Contig1298",
        "Length": 6988
    },
    {
        "Name": "Contig1299",
        "Length": 6988
    },
    {
        "Name": "Contig1300",
        "Length": 6988
    },
    {
        "Name": "Contig1301",
        "Length": 6988
    },
    {
        "Name": "Contig1302",
        "Length": 6988
    },
    {
        "Name": "Contig1303",
        "Length": 6988
    },
    {
        "Name": "Contig1304",
        "Length": 6988
    },
    {
        "Name": "Contig1305",
        "Length": 6988
    },
    {
        "Name": "Contig1306",
        "Length": 6988
    },
    {
        "Name": "Contig1307",
        "Length": 6988
    },
    {
        "Name": "Contig1308",
        "Length": 6988
    },
    {
        "Name": "Contig1309",
        "Length": 6988
    },
    {
        "Name": "Contig1310",
        "Length": 6988
    },
    {
        "Name": "Contig1311",
        "Length": 6988
    },
    {
        "Name": "Contig1312",
        "Length": 6988
    },
    {
        "Name": "Contig1313",
        "Length": 6988
    },
    {
        "Name": "Contig1314",
        "Length": 6988
    },
    {
        "Name": "Contig1315",
        "Length": 6988
    },
    {
        "Name": "Contig1316",
        "Length": 6988
    },
    {
        "Name": "Contig1317",
        "Length": 6988
    },
    {
        "Name": "Contig1318",
        "Length": 6988
    },
    {
        "Name": "Contig1319",
        "Length": 6988
    },
    {
        "Name": "Contig1320",
        "Length": 6988
    },
    {
        "Name": "Contig1321",
        "Length": 6988
    },
    {
        "Name": "Contig1322",
        "Length": 6988
    },
    {
        "Name": "Contig1323",
        "Length": 6988
    },
    {
        "Name": "Contig1324",
        "Length": 6988
    },
    {
        "Name": "Contig1325",
        "Length": 6988
    },
    {
        "Name": "Contig1326",
        "Length": 6988
    },
    {
        "Name": "Contig1327",
        "Length": 6988
    },
    {
        "Name": "Contig1328",
        "Length": 6988
    },
    {
        "Name": "Contig1329",
        "Length": 6988
    },
    {
        "Name": "Contig1330",
        "Length": 6988
    },
    {
        "Name": "Contig1331",
        "Length": 6988
    },
    {
        "Name": "Contig1332",
        "Length": 6988
    },
    {
        "Name": "Contig1333",
        "Length": 6988
    },
    {
        "Name": "Contig1334",
        "Length": 6988
    },
    {
        "Name": "Contig1335",
        "Length": 6988
    },
    {
        "Name": "Contig1336",
        "Length": 6975
    },
    {
        "Name": "Contig1337",
        "Length": 6973
    },
    {
        "Name": "Contig1338",
        "Length": 6270
    },
    {
        "Name": "Contig1339",
        "Length": 6108
    },
    {
        "Name": "Contig1340",
        "Length": 6089
    },
    {
        "Name": "Contig1341",
        "Length": 6089
    },
    {
        "Name": "Contig1342",
        "Length": 6086
    },
    {
        "Name": "Contig1343",
        "Length": 6071
    },
    {
        "Name": "Contig1344",
        "Length": 6067
    },
    {
        "Name": "Contig1345",
        "Length": 6065
    },
    {
        "Name": "Contig1346",
        "Length": 6065
    },
    {
        "Name": "Contig1347",
        "Length": 6065
    },
    {
        "Name": "Contig1348",
        "Length": 6051
    },
    {
        "Name": "Contig1349",
        "Length": 6050
    },
    {
        "Name": "Contig1350",
        "Length": 6048
    },
    {
        "Name": "Contig1351",
        "Length": 6047
    },
    {
        "Name": "Contig1352",
        "Length": 6037
    },
    {
        "Name": "Contig1353",
        "Length": 6035
    },
    {
        "Name": "Contig1354",
        "Length": 6034
    },
    {
        "Name": "Contig1355",
        "Length": 6031
    },
    {
        "Name": "Contig1356",
        "Length": 6028
    },
    {
        "Name": "Contig1357",
        "Length": 6025
    },
    {
        "Name": "Contig1358",
        "Length": 6025
    },
    {
        "Name": "Contig1359",
        "Length": 6024
    },
    {
        "Name": "Contig1360",
        "Length": 6021
    },
    {
        "Name": "Contig1361",
        "Length": 6021
    },
    {
        "Name": "Contig1362",
        "Length": 6020
    },
    {
        "Name": "Contig1363",
        "Length": 6020
    },
    {
        "Name": "Contig1364",
        "Length": 6020
    },
    {
        "Name": "Contig1365",
        "Length": 6020
    },
    {
        "Name": "Contig1366",
        "Length": 6019
    },
    {
        "Name": "Contig1367",
        "Length": 6018
    },
    {
        "Name": "Contig1368",
        "Length": 6015
    },
    {
        "Name": "Contig1369",
        "Length": 6015
    },
    {
        "Name": "Contig1370",
        "Length": 6014
    },
    {
        "Name": "Contig1371",
        "Length": 6014
    },
    {
        "Name": "Contig1372",
        "Length": 6013
    },
    {
        "Name": "Contig1373",
        "Length": 6010
    },
    {
        "Name": "Contig1374",
        "Length": 6009
    },
    {
        "Name": "Contig1375",
        "Length": 6008
    },
    {
        "Name": "Contig1376",
        "Length": 6008
    },
    {
        "Name": "Contig1377",
        "Length": 6007
    },
    {
        "Name": "Contig1378",
        "Length": 6007
    },
    {
        "Name": "Contig1379",
        "Length": 6006
    },
    {
        "Name": "Contig1380",
        "Length": 6006
    },
    {
        "Name": "Contig1381",
        "Length": 6005
    },
    {
        "Name": "Contig1382",
        "Length": 6005
    },
    {
        "Name": "Contig1383",
        "Length": 6004
    },
    {
        "Name": "Contig1384",
        "Length": 6004
    },
    {
        "Name": "Contig1385",
        "Length": 6004
    },
    {
        "Name": "Contig1386",
        "Length": 6004
    },
    {
        "Name": "Contig1387",
        "Length": 6003
    },
    {
        "Name": "Contig1388",
        "Length": 6003
    },
    {
        "Name": "Contig1389",
        "Length": 6003
    },
    {
        "Name": "Contig1390",
        "Length": 6001
    },
    {
        "Name": "Contig1391",
        "Length": 6000
    },
    {
        "Name": "Contig1392",
        "Length": 6000
    },
    {
        "Name": "Contig1393",
        "Length": 6000
    },
    {
        "Name": "Contig1394",
        "Length": 5999
    },
    {
        "Name": "Contig1395",
        "Length": 5999
    },
    {
        "Name": "Contig1396",
        "Length": 5998
    },
    {
        "Name": "Contig1397",
        "Length": 5998
    },
    {
        "Name": "Contig1398",
        "Length": 5998
    },
    {
        "Name": "Contig1399",
        "Length": 5997
    },
    {
        "Name": "Contig1400",
        "Length": 5997
    },
    {
        "Name": "Contig1401",
        "Length": 5997
    },
    {
        "Name": "Contig1402",
        "Length": 5997
    },
    {
        "Name": "Contig1403",
        "Length": 5997
    },
    {
        "Name": "Contig1404",
        "Length": 5996
    },
    {
        "Name": "Contig1405",
        "Length": 5995
    },
    {
        "Name": "Contig1406",
        "Length": 5995
    },
    {
        "Name": "Contig1407",
        "Length": 5994
    },
    {
        "Name": "Contig1408",
        "Length": 5994
    },
    {
        "Name": "Contig1409",
        "Length": 5993
    },
    {
        "Name": "Contig1410",
        "Length": 5992
    },
    {
        "Name": "Contig1411",
        "Length": 5992
    },
    {
        "Name": "Contig1412",
        "Length": 5992
    },
    {
        "Name": "Contig1413",
        "Length": 5992
    },
    {
        "Name": "Contig1414",
        "Length": 5992
    },
    {
        "Name": "Contig1415",
        "Length": 5992
    },
    {
        "Name": "Contig1416",
        "Length": 5992
    },
    {
        "Name": "Contig1417",
        "Length": 5991
    },
    {
        "Name": "Contig1418",
        "Length": 5991
    },
    {
        "Name": "Contig1419",
        "Length": 5991
    },
    {
        "Name": "Contig1420",
        "Length": 5991
    },
    {
        "Name": "Contig1421",
        "Length": 5991
    },
    {
        "Name": "Contig1422",
        "Length": 5991
    },
    {
        "Name": "Contig1423",
        "Length": 5991
    },
    {
        "Name": "Contig1424",
        "Length": 5990
    },
    {
        "Name": "Contig1425",
        "Length": 5990
    },
    {
        "Name": "Contig1426",
        "Length": 5990
    },
    {
        "Name": "Contig1427",
        "Length": 5990
    },
    {
        "Name": "Contig1428",
        "Length": 5990
    },
    {
        "Name": "Contig1429",
        "Length": 5990
    },
    {
        "Name": "Contig1430",
        "Length": 5990
    },
    {
        "Name": "Contig1431",
        "Length": 5990
    },
    {
        "Name": "Contig1432",
        "Length": 5989
    },
    {
        "Name": "Contig1433",
        "Length": 5989
    },
    {
        "Name": "Contig1434",
        "Length": 5989
    },
    {
        "Name": "Contig1435",
        "Length": 5989
    },
    {
        "Name": "Contig1436",
        "Length": 5989
    },
    {
        "Name": "Contig1437",
        "Length": 5989
    },
    {
        "Name": "Contig1438",
        "Length": 5989
    },
    {
        "Name": "Contig1439",
        "Length": 5988
    },
    {
        "Name": "Contig1440",
        "Length": 5988
    },
    {
        "Name": "Contig1441",
        "Length": 5988
    },
    {
        "Name": "Contig1442",
        "Length": 5988
    },
    {
        "Name": "Contig1443",
        "Length": 5988
    },
    {
        "Name": "Contig1444",
        "Length": 5988
    },
    {
        "Name": "Contig1445",
        "Length": 5988
    },
    {
        "Name": "Contig1446",
        "Length": 5988
    },
    {
        "Name": "Contig1447",
        "Length": 5988
    },
    {
        "Name": "Contig1448",
        "Length": 5988
    },
    {
        "Name": "Contig1449",
        "Length": 5988
    },
    {
        "Name": "Contig1450",
        "Length": 5988
    },
    {
        "Name": "Contig1451",
        "Length": 5988
    },
    {
        "Name": "Contig1452",
        "Length": 5988
    },
    {
        "Name": "Contig1453",
        "Length": 5988
    },
    {
        "Name": "Contig1454",
        "Length": 5988
    },
    {
        "Name": "Contig1455",
        "Length": 5988
    },
    {
        "Name": "Contig1456",
        "Length": 5988
    },
    {
        "Name": "Contig1457",
        "Length": 5988
    },
    {
        "Name": "Contig1458",
        "Length": 5988
    },
    {
        "Name": "Contig1459",
        "Length": 5988
    },
    {
        "Name": "Contig1460",
        "Length": 5988
    },
    {
        "Name": "Contig1461",
        "Length": 5988
    },
    {
        "Name": "Contig1462",
        "Length": 5988
    },
    {
        "Name": "Contig1463",
        "Length": 5988
    },
    {
        "Name": "Contig1464",
        "Length": 5988
    },
    {
        "Name": "Contig1465",
        "Length": 5988
    },
    {
        "Name": "Contig1466",
        "Length": 5988
    },
    {
        "Name": "Contig1467",
        "Length": 5988
    },
    {
        "Name": "Contig1468",
        "Length": 5988
    },
    {
        "Name": "Contig1469",
        "Length": 5988
    },
    {
        "Name": "Contig1470",
        "Length": 5988
    },
    {
        "Name": "Contig1471",
        "Length": 5988
    },
    {
        "Name": "Contig1472",
        "Length": 5988
    },
    {
        "Name": "Contig1473",
        "Length": 5988
    },
    {
        "Name": "Contig1474",
        "Length": 5988
    },
    {
        "Name": "Contig1475",
        "Length": 5988
    },
    {
        "Name": "Contig1476",
        "Length": 5988
    },
    {
        "Name": "Contig1477",
        "Length": 5987
    },
    {
        "Name": "Contig1478",
        "Length": 5987
    },
    {
        "Name": "Contig1479",
        "Length": 5083
    },
    {
        "Name": "Contig1480",
        "Length": 5036
    },
    {
        "Name": "Contig1481",
        "Length": 5016
    },
    {
        "Name": "Contig1482",
        "Length": 5014
    },
    {
        "Name": "Contig1483",
        "Length": 5011
    },
    {
        "Name": "Contig1484",
        "Length": 5004
    },
    {
        "Name": "Contig1485",
        "Length": 5002
    },
    {
        "Name": "Contig1486",
        "Length": 4998
    },
    {
        "Name": "Contig1487",
        "Length": 4996
    },
    {
        "Name": "Contig1488",
        "Length": 4996
    },
    {
        "Name": "Contig1489",
        "Length": 4995
    },
    {
        "Name": "Contig1490",
        "Length": 4995
    },
    {
        "Name": "Contig1491",
        "Length": 4994
    },
    {
        "Name": "Contig1492",
        "Length": 4993
    },
    {
        "Name": "Contig1493",
        "Length": 4992
    },
    {
        "Name": "Contig1494",
        "Length": 4992
    },
    {
        "Name": "Contig1495",
        "Length": 4991
    },
    {
        "Name": "Contig1496",
        "Length": 4990
    },
    {
        "Name": "Contig1497",
        "Length": 4989
    },
    {
        "Name": "Contig1498",
        "Length": 4988
    },
    {
        "Name": "Contig1499",
        "Length": 4988
    },
    {
        "Name": "Contig1500",
        "Length": 4988
    },
    {
        "Name": "Contig1501",
        "Length": 4988
    },
    {
        "Name": "Contig1502",
        "Length": 4988
    },
    {
        "Name": "Contig1503",
        "Length": 4988
    },
    {
        "Name": "Contig1504",
        "Length": 4988
    },
    {
        "Name": "Contig1505",
        "Length": 4988
    },
    {
        "Name": "Contig1506",
        "Length": 4988
    },
    {
        "Name": "Contig1507",
        "Length": 4988
    },
    {
        "Name": "Contig1508",
        "Length": 4988
    },
    {
        "Name": "Contig1509",
        "Length": 4988
    },
    {
        "Name": "Contig1510",
        "Length": 4988
    },
    {
        "Name": "Contig1511",
        "Length": 4988
    },
    {
        "Name": "Contig1512",
        "Length": 4988
    },
    {
        "Name": "Contig1513",
        "Length": 4988
    },
    {
        "Name": "Contig1514",
        "Length": 4988
    },
    {
        "Name": "Contig1515",
        "Length": 4988
    },
    {
        "Name": "Contig1516",
        "Length": 4006
    },
    {
        "Name": "Contig1517",
        "Length": 4000
    },
    {
        "Name": "Contig1518",
        "Length": 3993
    },
    {
        "Name": "Contig1519",
        "Length": 3992
    },
    {
        "Name": "Contig1520",
        "Length": 3991
    },
    {
        "Name": "Contig1521",
        "Length": 3988
    },
    {
        "Name": "Contig1522",
        "Length": 3988
    },
    {
        "Name": "Contig1523",
        "Length": 3988
    },
    {
        "Name": "Contig1524",
        "Length": 3988
    },
    {
        "Name": "Contig1525",
        "Length": 3988
    },
    {
        "Name": "Contig1526",
        "Length": 3988
    },
    {
        "Name": "Contig1527",
        "Length": 2988
    }
]
export default Zi_3